import MuiDialog from 'components/MuiDialog';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const Complete = ({ isOpen, onClose }: Props) => (
  <MuiDialog.Confirm
    isOpen={isOpen}
    title="欢迎加入SmartNurse大家庭！"
    message="审核最多需要1天时间"
    onClose={onClose}
  />
);

export default Complete;
